module.exports = __webpack_public_path__ + "static/media/The_Rock_Johnson.9e8b3a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/The_Rock_Johnson.jpg
// module id = 416
// module chunks = 0